import fetch from '../utils/fetchService';
import Config from '../config';
import {
  handleErrors,
  parseAsJson,
} from '../utils/requestHelpers';

export const fetchConnectionRunStatus = async ({ periodName, connection }) => await fetch(
  Config.endpoints.FETCH_CONNECTION_RUN_STATUS
    .replace(/:periodName/, periodName)
    .replace(/:connectionName/, connection)
)
  .then(handleErrors({ errorMessage: 'Fetching Connection Run Status failed' }))
  .then(parseAsJson);

export const fetchTotalQuality = async ({ periodName }) => await fetch(
  Config.endpoints.FETCH_TOTAL_QUALITY
    .replace(/:periodName/, periodName)
)
  .then(handleErrors({ errorMessage: 'Fetching Total Provision Quality failed' }))
  .then(parseAsJson);

export const fetchConnectionQuality = async ({ periodName, connectionName }) => await fetch(
  Config.endpoints.FETCH_CONNECTION_QUALITY
    .replace(/:periodName/, periodName)
    .replace(/:connectionName/, connectionName)
)
  .then(handleErrors({ errorMessage: 'Fetching Connection Quality failed' }))
  .then(parseAsJson);

export const fetchConnectionsQuality = async ({ periodName }) => await fetch(
  Config.endpoints.FETCH_CONNECTIONS_QUALITY
    .replace(/:periodName/, periodName)
)
  .then(handleErrors({ errorMessage: 'Fetching Connections Quality failed' }))
  .then(parseAsJson);

export const fetchBusinessQuality = async ({ periodName, businessCode }) => await fetch(
  Config.endpoints.FETCH_BUSINESS_QUALITY
    .replace(/:periodName/, periodName)
    .replace(/:businessCode/, businessCode)
)
  .then(handleErrors({ errorMessage: 'Fetching Business Quality failed' }))
  .then(parseAsJson);

export const fetchBusinessesQuality = async ({ periodName }) => await fetch(
  Config.endpoints.FETCH_BUSINESSES_QUALITY
    .replace(/:periodName/, periodName)
)
  .then(handleErrors({ errorMessage: 'Fetching Businesses Quality failed' }))
  .then(parseAsJson);

export const fetchUsefulStats = async ({ periodName }) => await fetch(
  Config.endpoints.FETCH_USEFUL_STATS
    .replace(/:periodName/, periodName)
)
  .then(handleErrors({ errorMessage: 'Fetching Useful Stats failed' }))
  .then(parseAsJson);

export const fetchConnectionMonitorData = async periodName => await fetch(
  Config.endpoints.FETCH_CONNECTION_MONITOR_DATA
    .replace(/:periodName/, periodName)
)
  .then(handleErrors({ errorMessage: 'Fetching Connection Monitor data failed' }))
  .then(parseAsJson);

export const fetchHeartbeatMonitorStatus = async () => await fetch(
  Config.endpoints.FETCH_HEARTBEAT_MONITOR_STATUS
)
  .then(handleErrors({ errorMessage: 'Fetching Heartbeat Monitor Status failed' }))
  .then(parseAsJson);

export const fetchBusinessCodes = async () => await fetch(
  Config.endpoints.FETCH_BUSINESS_CODES
)
  .then(handleErrors({ errorMessage: 'Fetching Business Codes failed' }))
  .then(parseAsJson);

export const fetchNotificationsPanelData = async periodName => await fetch(
  Config.endpoints.FETCH_NOTIFICATIONS_PANEL_DATA
    .replace(/:periodName/, periodName)
)
  .then(handleErrors({ errorMessage: 'Fetching Notifications Panel data failed' }))
  .then(parseAsJson);

export const fetchCommunications = async () => await fetch(
  Config.endpoints.FETCH_COMMUNICATIONS
)
  .then(handleErrors({ errorMessage: 'Fetching Communication Messages data failed' }))
  .then(parseAsJson);
